import _ from "lodash";

export const substituirElementoArray = (array, novoItem, funcaoComparacao) => {
    const indice = _.findIndex(array, funcaoComparacao);
    if (indice < 0) return;

    array[indice] = novoItem;
    return array;
};

export const agruparItensPorPares = (array) => {
    let arrayAgrupado = [];

    for (let i = 0; i < array.length; i += 2) {
        let par = [array[i], array[i + 1]];

        arrayAgrupado.push(par);
    }

    return arrayAgrupado;
};
